import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FundaeGroupingsList from './FundaeGroupingsList';

const FundaeGroupingsSettingsPage: React.FC = () => {
    const pageHeader = {
        title: 'Agrupaciones Fundae',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Agrupaciones Fundae', href: menuRoutes.settings.path + menuRoutes.settings.fundae_groupings },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />
            <div className="p-6">
                <FundaeGroupingsList />
            </div>
        </div>
    );
};

export default FundaeGroupingsSettingsPage;
